
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    iconName: {
      type: String,
      default: '',
    },
    iconTheme: {
      type: String,
      default: '',
    },
    iconSize: {
      type: String,
      default: '',
    },
  },
});
